export default __webpack_public_path__ + "static/media/pay respects 5.c0b2c19f.png";